import api from "@/lib/axios";

export const birpApi = {
    listReports: (params) =>
        api.get("/birp/reports", { params }).then((r) => r.data),
    getReport: (id) => api.get(`/birp/reports/${id}`).then((r) => r.data),
    generate: (data) =>
        api
            .post("/birp/reports/generate", data, { timeout: 180000 })
            .then((r) => r.data),
    update: (id, sections) =>
        api.patch(`/birp/reports/${id}`, sections).then((r) => r.data),
    approve: (id) =>
        api.post(`/birp/reports/${id}/approve`).then((r) => r.data),
    reject: (id) =>
        api.post(`/birp/reports/${id}/reject`).then((r) => r.data),
    remove: (id) => api.delete(`/birp/reports/${id}`).then((r) => r.data),
    listTemplates: () => api.get("/birp/templates").then((r) => r.data),
    datesWithData: (individualId, windowDays = 60) =>
        api
            .get(`/birp/individuals/${individualId}/dates-with-data`, {
                params: { window_days: windowDays },
            })
            .then((r) => r.data),
    downloadPdf: async (id) => {
        // Returns { blob, filename }
        const resp = await api.get(`/birp/reports/${id}/pdf`, {
            responseType: "blob",
        });
        // Filename comes back in Content-Disposition; fall back to a safe default.
        const disp =
            resp.headers?.["content-disposition"] ||
            resp.headers?.get?.("content-disposition") ||
            "";
        const match = /filename\s*=\s*"?([^";]+)"?/i.exec(disp);
        const filename = match ? match[1] : `BIRP_${id}.pdf`;
        return { blob: resp.data, filename };
    },
};
